import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=03a7b52a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=03a7b52a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a7b52a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03a7b52a')) {
      api.createRecord('03a7b52a', component.options)
    } else {
      api.reload('03a7b52a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=03a7b52a&scoped=true&", function () {
      api.rerender('03a7b52a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2m5Qwtv0T70tC/JS/comp/GuestBox.vue"
export default component.exports